import { ReactNode } from 'react';

import { TranslatableText, Translate } from '@dreryk/react-common';
import { Portal, StyledFlex } from '@dreryk/react-components';

import { StyledExtendedDosageHeaderActions } from './ExtendedDosageHeaderActionsPortal.styled';

const EXTENDED_DOSAGE_HEADER_ACTIONS_PORTAL_ID = 'extendedDosageHeaderActions';

type ExtendedDosageModalTitleProps = {
   readonly title: TranslatableText;
};

export const ExtendedDosageModalTitle = (props: ExtendedDosageModalTitleProps): JSX.Element => {
   return (
      <StyledFlex alignItems={'center'} justifyContent={'space-between'}>
         <Translate>{props.title}</Translate>
         <StyledExtendedDosageHeaderActions
            testId={'extendedDosageHeaderActions'}
            id={EXTENDED_DOSAGE_HEADER_ACTIONS_PORTAL_ID}
         />
      </StyledFlex>
   );
};

type ExtendedDosageHeaderActionsPortalProps = {
   readonly children: ReactNode;
};

export const ExtendedDosageHeaderActionsPortal = (props: ExtendedDosageHeaderActionsPortalProps): JSX.Element => {
   return <Portal containerId={EXTENDED_DOSAGE_HEADER_ACTIONS_PORTAL_ID}>{props.children}</Portal>;
};
